import { hiddenStyleList, installerUrl, protocol } from '../constants/constants';
import { messages } from '../constants/messages';
import { safariClient } from '../helpers/client/safari-client';
import { errorLog, isSafari } from '../helpers/helpers';
import { websocketService } from '../helpers/ws';
import { asperaSdk } from '../index';
var AsperaSdkGlobals = /** @class */ (function () {
    function AsperaSdkGlobals() {
        /** The URL of the IBM Aspera HTTP server to use with the SDK */
        this.asperaAppUrl = 'http://127.0.0.1';
        /** The URL of the IBM Aspera Desktop HTTP server to use with the SDK */
        this.rpcPort = 33024;
        /** The default URL to check for latest Aspera installers */
        this.installerUrl = installerUrl;
        /** Indication that the server has been verified as working */
        this.asperaAppVerified = false;
        /** Indicate if multiple session is supported */
        this.supportMultipleUsers = false;
        /** Map of drop zones created by querySelector */
        this.dropZonesCreated = new Map();
    }
    AsperaSdkGlobals.prototype.backupLaunchMethod = function (url) {
        window.alert(messages.loadingProtocol);
        window.location.href = url;
    };
    /**
     * Launch the IBM Aspera App via protocol url. By default, a hidden IFRAME attempts to
     * open the app but if that fails a fallback of opening a new window happens.
     */
    AsperaSdkGlobals.prototype.launch = function () {
        var _this = this;
        try {
            var element = document.createElement('iframe');
            element.src = protocol;
            element.onerror = function (error) {
                errorLog(messages.failedToGenerateIframe, error);
                _this.backupLaunchMethod(protocol);
            };
            element.setAttribute('style', hiddenStyleList);
            document.body.appendChild(element);
        }
        catch (error) {
            errorLog(messages.failedToGenerateIframe, error);
            this.backupLaunchMethod(protocol);
        }
    };
    return AsperaSdkGlobals;
}());
var AsperaSdkInfo = /** @class */ (function () {
    function AsperaSdkInfo() {
    }
    return AsperaSdkInfo;
}());
export { AsperaSdkInfo };
var TransferResponse = /** @class */ (function () {
    function TransferResponse() {
    }
    return TransferResponse;
}());
export { TransferResponse };
var ActivityMessage = /** @class */ (function () {
    function ActivityMessage() {
    }
    return ActivityMessage;
}());
export { ActivityMessage };
var ActivityTracking = /** @class */ (function () {
    function ActivityTracking() {
        /** Map of callbacks that receive transfer update events */
        this.activity_callbacks = new Map();
        /** Map of callbacks that received removed transfer events */
        this.removed_callbacks = new Map();
        /** Map of callbacks that receive connection events */
        this.event_callbacks = new Map();
        /** Map of callbacks that receive Safari extension events */
        this.safari_extension_callbacks = new Map();
        /** Keep track of the last WebSocket event **/
        this.lastWebSocketEvent = 'CLOSED';
        /** Keep track of the last notified WebSocket event **/
        this.lastNotifiedWebSocketEvent = undefined;
        /** Keep track of the last Safari extension event **/
        this.lastSafariExtensionEvent = 'DISABLED';
    }
    /**
     * Notify all consumers when a message is received from the websocket
     *
     * @param message the message received from the websocket
     */
    ActivityTracking.prototype.handleTransferActivity = function (message) {
        if (message.type === 'transferUpdated') {
            this.activity_callbacks.forEach(function (callback) {
                if (typeof callback === 'function') {
                    callback(message.data);
                }
            });
        }
        if (message.type === 'transferRemoved') {
            this.removed_callbacks.forEach(function (callback) {
                if (typeof callback === 'function') {
                    callback(message.data);
                }
            });
        }
    };
    /**
     * Handle and notify if needed when a connection webSocketEvent occurs. For example, when the SDK
     * websocket connection to IBM Aspera App is closed or reconnected.
     *
     * @param webSocketEvent the event type.
     */
    ActivityTracking.prototype.handleWebSocketEvents = function (webSocketEvent) {
        if (this.lastWebSocketEvent === webSocketEvent) {
            return;
        }
        this.lastWebSocketEvent = webSocketEvent;
        this.notifyWebSocketEvent(webSocketEvent);
    };
    /**
     * Notify all consumers when a connection webSocketEvent occurs.
     *
     * @param webSocketEvent the event type.
     */
    ActivityTracking.prototype.notifyWebSocketEvent = function (webSocketEvent) {
        if (this.lastNotifiedWebSocketEvent === webSocketEvent) {
            return;
        }
        this.lastNotifiedWebSocketEvent = webSocketEvent;
        this.event_callbacks.forEach(function (callback) {
            if (typeof callback === 'function') {
                callback(webSocketEvent);
            }
        });
    };
    /**
     * Notify all consumers when the client changes status. For example, when
     * IBM Aspera App is launched or closed.
     *
     * @param running whether the client is running or not.
     */
    ActivityTracking.prototype.handleClientEvents = function (running) {
        var webSocketEvent;
        if (!running) {
            webSocketEvent = 'CLOSED';
        }
        else {
            webSocketEvent = this.lastWebSocketEvent;
        }
        this.notifyWebSocketEvent(webSocketEvent);
    };
    /**
     * Notify all consumers when a Safari extension safariExtensionEvent occurs (enabled/disabled).
     *
     * @param safariExtensionEvent the event type.
     */
    ActivityTracking.prototype.handleSafariExtensionEvents = function (safariExtensionEvent) {
        if (this.lastSafariExtensionEvent === safariExtensionEvent) {
            return;
        }
        this.safari_extension_callbacks.forEach(function (callback) {
            if (typeof callback === 'function') {
                callback(safariExtensionEvent);
            }
        });
        this.lastSafariExtensionEvent = safariExtensionEvent;
    };
    /**
     * Set up the activity tracking with IBM Aspera.
     *
     * @returns a promise that resolves when the websocket connection is established.
     * Currently, this promise does not reject.
     */
    ActivityTracking.prototype.setup = function () {
        var _this = this;
        if (asperaSdk.globals.sessionId) {
            this.registerDesktopAppSession();
        }
        if (isSafari()) {
            return safariClient.monitorTransferActivity();
        }
        return websocketService.init()
            .then(function () {
            websocketService.registerMessage('transfer_activity', function (data) { return _this.handleTransferActivity(data); });
            websocketService.registerEvent(function (status) { return _this.handleWebSocketEvents(status); });
        });
    };
    /**
     * Register a callback for getting transfers back to the consumer
     *
     * @param callback the function to call with the array of transfers
     *
     * @returns the ID of the callback index
     */
    ActivityTracking.prototype.setCallback = function (callback) {
        if (typeof callback !== 'function') {
            errorLog(messages.callbackIsNotFunction);
            return;
        }
        var id = "callback-".concat(this.activity_callbacks.size + 1);
        this.activity_callbacks.set(id, callback);
        return id;
    };
    /**
     * Remove the callback (deregister) from the list of callbacks
     *
     * @param id the string of the callback to remove
     */
    ActivityTracking.prototype.removeCallback = function (id) {
        this.activity_callbacks.delete(id);
    };
    /**
     * Register a callback for getting transfers back to the consumer
     *
     * @param callback the function to call with the array of transfers
     *
     * @returns the ID of the callback index
     */
    ActivityTracking.prototype.setRemovedCallback = function (callback) {
        if (typeof callback !== 'function') {
            errorLog(messages.callbackIsNotFunction);
            return;
        }
        var id = "callback-".concat(this.removed_callbacks.size + 1);
        this.removed_callbacks.set(id, callback);
        return id;
    };
    /**
     * Remove the callback (deregister) from the list of callbacks
     *
     * @param id the string of the callback to remove
     */
    ActivityTracking.prototype.removeRemovedCallback = function (id) {
        this.removed_callbacks.delete(id);
    };
    /**
     * Register a callback for getting websocket events back to the consumer
     *
     * @param callback the function to call with the websocket event
     *
     * @returns the ID of the callback index
     */
    ActivityTracking.prototype.setWebSocketEventCallback = function (callback) {
        if (typeof callback !== 'function') {
            errorLog(messages.callbackIsNotFunction);
            return;
        }
        var id = "callback-".concat(this.event_callbacks.size + 1);
        this.event_callbacks.set(id, callback);
        callback(this.lastWebSocketEvent);
        return id;
    };
    /**
     * Remove the callback (deregister) from the list of callbacks
     *
     * @param id the string of the callback to remove
     */
    ActivityTracking.prototype.removeWebSocketEventCallback = function (id) {
        this.event_callbacks.delete(id);
    };
    /**
     * Register a callback for getting Safari extension events back to the consumer
     *
     * @param callback the function to call with the websocket event
     *
     * @returns the ID of the callback index
     */
    ActivityTracking.prototype.setSafariExtensionEventCallback = function (callback) {
        if (typeof callback !== 'function') {
            errorLog(messages.callbackIsNotFunction);
            return;
        }
        var id = "callback-".concat(this.safari_extension_callbacks.size + 1);
        this.safari_extension_callbacks.set(id, callback);
        callback(this.lastSafariExtensionEvent);
        return id;
    };
    /**
     * Remove the callback (deregister) from the list of callbacks
     *
     * @param id the string of the callback to remove
     */
    ActivityTracking.prototype.removeSafariExtensionEventCallback = function (id) {
        this.safari_extension_callbacks.delete(id);
    };
    ActivityTracking.prototype.registerDesktopAppSession = function () {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = "aspera://initialize?app_id=".concat(asperaSdk.globals.appId, "&session_id=").concat(asperaSdk.globals.sessionId);
        document.body.appendChild(iframe);
        setTimeout(function () {
            document.body.removeChild(iframe);
        }, 1000);
    };
    return ActivityTracking;
}());
export { ActivityTracking };
var AsperaSdk = /** @class */ (function () {
    function AsperaSdk() {
        /** Global information about IBM Aspera */
        this.globals = new AsperaSdkGlobals();
        /** Activity tracking for watching transfers */
        this.activityTracking = new ActivityTracking();
    }
    Object.defineProperty(AsperaSdk.prototype, "isReady", {
        /**
         * Check if IBM Aspera is ready to be used and has been verified.
         *
         * @returns a boolean indicating if SDK can be used for requests
         */
        get: function () {
            return this.globals.asperaAppVerified && this.globals.appId !== '';
        },
        enumerable: false,
        configurable: true
    });
    return AsperaSdk;
}());
export { AsperaSdk };
